import * as React from "react";
const SvgLeftMiniArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 7, height: 12, fill: "none", viewBox: "0 0 7 12", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m5.667 11.5 1.175-1.293L3.025 6l3.817-4.207L5.667.5l-5 5.5z" }));
export default SvgLeftMiniArrow;
